import React, { useRef, useEffect, useState  } from "react";
import jsPDF from "jspdf";
import { exportarExcel } from '../utilerias/exportExcel';
import autoTable from "jspdf-autotable"; // IMPORTANTE
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
//import logo from "../logo.svg"; // Importar logo
import { Card } from 'react-bootstrap';
import { Calendar } from "primereact/calendar";
import { Dropdown } from "primereact/dropdown";
import { Toolbar } from 'primereact/toolbar';
import { SplitButton } from 'primereact/splitbutton';
import { getFacturas}from '../api/facturaService'; 
import { getClientes } from '../api/clientesService';//getClientes
import {getReportes} from '../api/reportesServices';
import { format ,startOfToday,
  endOfToday,
  startOfYesterday,
  endOfYesterday,
  subDays,
  startOfMonth,
  endOfMonth,
  startOfYear,
  endOfYear} from 'date-fns';
import { es } from 'date-fns/locale'; 
import { Dialog } from 'primereact/dialog';
import { Checkbox } from 'primereact/checkbox';
import { ListBox } from 'primereact/listbox';
import {getImpuestos}  from "../api/monedaFormaPagoService"
import { Toast } from 'primereact/toast';

function MainReportes() {
const [seleccionados, setSeleccionados] = useState([]);
const [rangoFechas, setRangoFechas] = useState(null);
const [rangoSeleccionado, setRangoSeleccionado] = useState(null);
const [cliente, setCliente] = useState(null); 
const [clientes, setClientes] = useState([]);
//const [impuestos, setImpuestos] = useState([]);

const [tipoReporte,setTipoReporte] =useState(null);
const [camposReporte, setCamposReporte] = useState([]);

const [todosClientes, setTodosClientes] = useState(true); // Sí por defecto
const [textoRango, setTextoRango] = useState('');

const toast = useRef(null);
const dt = useRef(null);
const [resultadoReporte, setResultadoReporte] = useState([]);
const [columnasSeleccionadas, setColumnasSeleccionadas] = useState([]);

useEffect(() =>{
  const fetchData = async () => 
    {
      const data = await getClientes();  
      const activas = data.filter(e => e.activo === true); // o e.estatus === "Activo"
      setClientes(activas); 
    };
   
  fetchData();
}, []);


  const tiposReportes = [
  { label: 'Reporte Detallado', value: 'DETALLADO' },
  { label: 'Reporte General', value: 'GENERAL' },
  { label: 'Reporte de Facturas de pago', value: 'PAGO' },
  //{ label: 'Reporte de Facturas Pendientes de pago', value: 'PENDIENTESPAGO' }
  { label: 'Reporte de Saldo de Facturas', value: 'SALDOFACTURAS'}
];

 const camposPorReporte ={
  GENERAL:[
    {label:'NombreCliente', value:'datosReceptor.razonSocial', format:'text'},
    {label:'RUC', value:'datosReceptor.ruc', format:'text'},
    {label:'Status', value:'status', format:'text'},
    {label:'Subtotal', value:'subTotal' ,format: 'decimal'},
    {label:'Impuestos', value:'totalImpuestos', format: 'decimal'},
    {label:'TotalPagar', value:'totalPagar', format: 'decimal'},

  ],
  DETALLADO:[
    {label:'FacturaID', value:'facturaId', format: 'integer'},
    {label:'Serie', value:'serie', format:'text'},
    {label:'Folio', value:'folio', format: 'integer'},
    {label:'NombreCliente', value:'datosReceptor.razonSocial', format:'text'},
    {label:'RUC', value:'datosReceptor.ruc', format:'text'},
    {label:'Concepto', value:'detalleFactura.nombre', format:'text'},
    {label:'Cantidad', value:'detalleFactura.cantidad', format: 'integer'},
    {label:'PrecioUnitario', value:'detalleFactura.precioUnitario', format: 'decimal'},
    {label:'Importe', value:'detalleFactura.importe', format: 'decimal'},
    {label:'Status', value:'status', format:'text'},
    {label:'FechaEmision', value:'fechaEmision', format:'date'},    
    {label:'FormaPago', value:'formaPago' , format:'text'},
    {label:'MetodoPago', value:'medioPago' , format:'text'},
    {label:'Subtotal', value:'subTotal', format: 'decimal'},
    {label:'Impuestos', value:'totalImpuestos', format: 'decimal'},   
    {label:'TotalPagar', value:'totalPagar', format: 'decimal'},
  ],
  PAGO:[
     {label:'RUC', value:'ruc' , format:'text'},
     {label:'FechaPago', value:'fechaPago', format:'date'},
     {label:'ID', value:'documentoPagoId' , format: 'integer'},
     {label:'Serie', value:'datosDocumento.serie' , format:'text'},
     {label:'Folio', value:'datosDocumento.folio' , format: 'integer'},
     {label:'NumeroPago', value:'datosDocumento.numeroParcialidad' , format: 'integer'},
     {label:'SaldoAnterior', value:'datosDocumento.saldoAnterior', format: 'decimal'},  
     {label:'SaldoPagado', value:'datosDocumento.saldoPagado', format: 'decimal'},     
     {label:'MontoPago', value:'totalPagado', format: 'decimal'},
     {label:'MonedaPago', value:'codigoMoneda' , format:'text'},
     {label:'FormaPago', value:'formaPago' , format:'text'},
  ],
  SALDOFACTURAS:[
    {label:'Serie', value:'serie' , format:'text'},
    {label:'Folio', value:'folio' , format: 'integer'},
    {label:'FechaEmision', value:'fechaEmision', format:'date'},
    {label:'Cliente', value:'datosReceptor.razonSocial' , format:'text'},    
    {label:'RUC', value:'datosReceptor.ruc' , format:'text'},
    {label:'TotalFactura', value:'totalPagar', format: 'decimal'},    
    {label:'TotalPagado', value:'totalPagado', format: 'decimal'},
    {label: 'SaldoPendiente', value: 'saldoPendiente' ,format: 'decimal'}  
  ]
 };
const opcionesRango = [
  { label: 'Hoy', value: 'hoy' },
  { label: 'Ayer', value: 'ayer' },
  { label: 'Últimos 7 días', value: '7dias' },
  { label: 'Últimos 30 días', value: '30dias' },
  { label: 'Este mes', value: 'mesActual' },
  { label: 'Mes pasado', value: 'mesPasado' },
  { label: 'Este año', value: 'anioActual' },
  { label: 'Rango personalizado', value: 'custom' }
];

const onChangeReporte=(e)=>
{
  const reporte = e.value;
  setTipoReporte(reporte);
  setCamposReporte(camposPorReporte[reporte] || []);
  setSeleccionados([]); // limpiar selección anterior
}

 const startContent = (
        <React.Fragment>
            <h5>Reportes genéricos</h5>
        </React.Fragment>
    );
    const itemTemplate = (option) => {
  return (
    <div className="flex align-items-center gap-2">
      <Checkbox checked={seleccionados.includes(option.value)} />
      <span>{option.label}</span>
    </div>
  );
};

const aplicarRango = (tipo) => {
  let inicio, fin;

  switch (tipo) {
    case 'hoy':
      inicio = startOfToday();
      fin = endOfToday();
      break;

    case 'ayer':
      inicio = startOfYesterday();
      fin = endOfYesterday();
      break;

    case '7dias':
      inicio = subDays(new Date(), 6);
      fin = new Date();
      break;

    case '30dias':
      inicio = subDays(new Date(), 29);
      fin = new Date();
      break;

    case 'mesActual':
      inicio = startOfMonth(new Date());
      fin = endOfMonth(new Date());
      break;

    case 'mesPasado':
      const lastMonth = subDays(startOfMonth(new Date()), 1);
      inicio = startOfMonth(lastMonth);
      fin = endOfMonth(lastMonth);
      break;

    case 'anioActual':
      inicio = startOfYear(new Date());
      fin = endOfYear(new Date());
      break;

    case 'custom':
        setTextoRango('');
      return;

    default:
      return;
  }

  setRangoFechas([inicio, fin]);
  setTextoRango(formatearRango([inicio, fin]));
};
const formatearRango = (rango) => {
  if (!rango || !rango[0] || !rango[1]) return '';

  return `${format(rango[0], "MMMM d, yyyy", { locale: es })} - ${format(rango[1], "MMMM d, yyyy", { locale: es })}`;
};

const opcionesTodosClientes = [
  { label: 'Sí', value: true },
  { label: 'No', value: false }
];

const generarReporte = async () => {
  // validaciones básicas
  if (!tipoReporte) {
    toast.current.show({
      severity: 'warn',
      summary: 'Atención',
      detail: 'Selecciona un tipo de reporte',
      life: 3000
    });
    return;
  }

  if (!rangoFechas || rangoFechas.length !== 2) {
    toast.current.show({
      severity: 'warn',
      summary: 'Atención',
      detail: 'Selecciona un rango de fechas',
      life: 3000
    });
    return;
  }

  if (seleccionados.length === 0) {
    toast.current.show({
      severity: 'warn',
      summary: 'Atención',
      detail: 'Selecciona al menos un campo',
      life: 3000
    });
    return;
  }
  const camposSeleccionados = camposReporte
  .filter(c => seleccionados.includes(c.value))
  .map(c => ({
    label: c.label,
    value: c.value
  }));

  const payload = {
    tipoReporte,
    campos: camposSeleccionados,
    fechaInicio: rangoFechas[0],
    fechaFin: rangoFechas[1],
    todosClientes,
    clienteRuc: cliente?.ruc || null
  };

  console.log('PAYLOAD ENVIADO AL BACKEND:', payload);

  const resultado = await getReportes(payload);
  const resultadoFormateado = resultado.map(row => ({
    ...row,
    RUC: row.RUC ? `="${row.RUC}"` : row.RUC
  }));

  setResultadoReporte(resultadoFormateado);
  setColumnasSeleccionadas(camposSeleccionados);

  await  exportarExcel({
      empresa: 'MI EMPRESA S.A.',
      nombreReporte: tiposReportes.find(t => t.value === tipoReporte)?.label,
      fecha: new Date(),
      columnas: camposSeleccionados,
      datos: resultado,
      nombreArchivo: `Reporte_${tipoReporte}`
    });
};

return (
  <>
  <Toast ref={toast} />
    <h4>Reportes</h4>  
    <Card>
        <Toolbar  start={startContent}  >  </Toolbar>  
    </Card>
    <Card>
      <div class="grid">
        <div class="col-3">
          <div className="m-2"><strong>Campos :</strong></div>
          <div className="m-2">
          <Checkbox 
        inputId="selectAll"
        checked={seleccionados.length === camposReporte.length}
        onChange={(e) => {
          if (e.checked) {
            setSeleccionados(camposReporte.map(c => c.value));
          } else {
            setSeleccionados([]);
          }
        }}
      />  <label htmlFor=""></label>    
        Seleccionar todos
      </div>
    
          <ListBox
        value={seleccionados}
        options={camposReporte}
        onChange={(e) => setSeleccionados(e.value)}
        itemTemplate={itemTemplate}
        multiple
        checkmark
        optionLabel="label"
        emptyMessage="No hay campos"
        className="w-full m-2"
        listStyle={{ maxHeight: '250px' }} />

        </div>
      <div class="col-8">
        <div class="row">
          <div className="m-2"><strong>Reporte :</strong></div>
         
          <Dropdown 
          value={tipoReporte}
          options={tiposReportes}
          onChange={onChangeReporte}
          placeholder="Selecciona un reporte"
          className="col-8"></Dropdown>
        </div>
        
        <div class="row">
          <div className="m-2"><strong>Fechas :</strong></div>
          <Dropdown  value={rangoSeleccionado}
          options={opcionesRango}
          onChange={(e) => {
            setRangoSeleccionado(e.value);
            aplicarRango(e.value);
          }}
    placeholder="Seleccionar rango"
    className="col-8" 
    valueTemplate={() =>
    textoRango ? textoRango : 'Seleccionar rango'
  }
    />
    {rangoSeleccionado === 'custom' && (
    <Calendar
      value={rangoFechas}
      onChange={(e) => {
        setRangoFechas(e.value);
        setTextoRango(formatearRango(e.value));
      }}
      selectionMode="range"
      readOnlyInput
      dateFormat="dd/mm/yy"
      placeholder="Rango personalizado"
       className="col-4"
    />
  )}

    </div>
    {/* {textoRango && (
  <div className="mt-2 text-sm text-gray-600">
    <strong>Rango seleccionado:</strong> {textoRango}
  </div>
)} */}
    <div class="row">
    <div className="m-2"><strong>Todos los clientes :</strong></div>
    <Dropdown className="col"
          value={todosClientes}
        options={opcionesTodosClientes}
        onChange={(e) => {
          setTodosClientes(e.value);
          if (e.value) {
            setCliente(null); // limpiar cliente si vuelve a "Sí"
          }
        }}
        optionLabel="label"/>

{!todosClientes && (
          <Dropdown value={cliente} onChange={(e) => setCliente(e.value)} options={clientes}   
                placeholder="Selecciona un cliente"  className="col-7" optionLabel="razonSocial"
                itemTemplate={(option) => `${option.ruc} - ${option.razonSocial}`}
                valueTemplate={(option, props) => option ? `${option.ruc} - ${option.razonSocial}` : props.placeholder} ></Dropdown>
                )}
        </div>
        <div class="row">
          
          <Button className="m-2" 
          icon="pi pi-spinner-dotted"  
          label="Generar reporte" 
          severity="success"
          onClick={generarReporte}  />

          <DataTable
            ref={dt}
            value={resultadoReporte}
            paginator
            rows={10}
            emptyMessage="No hay datos"
             style={{ display: 'none' }}
          >
            {columnasSeleccionadas.map(col => (
              <Column
                key={col.label}
                field={col.label}
                header={col.label}
              />
            ))}
          </DataTable>          
        </div>
      </div>   
    </div>
    </Card>

  </>
);
}

export default MainReportes; 
